module.exports = __webpack_public_path__ + "static/img/apply2.bf1b786c.png";